import PubSub from "./pubsub.js";

// QUICK ADD TO CART
if (!customElements.get("cart-quick-add")) {
  class CartQuickAdd extends HTMLElement {
    constructor() {
      super();

      this.device = "";

      this.pubsub = PubSub;

      this.cta = this.querySelector(".quick-add-cta") || null;
      this.type = this.cta?.dataset.quickAddType || null;

      this.quickAddMultiPanel =
        this.querySelector(".quick-add-multi-panel") || "";
      this.quickAddMultiPanelClose = this.querySelector(
        ".quick-add-multi-panel-close"
      );
      this.variantCtas = this.querySelectorAll(".variant-radio");

      this.titleHover = this.querySelector(".variant-hover-title");
      this.descriptionHover = this.querySelector(".variant-hover-description");
    }

    // DEVIC EOBSERVER
    deviceObserver = () => {
      const mql = window.matchMedia("(max-width: 1279px)");

      this.device = mql.matches ? "mobile" : "desktop";

      mql.onchange = (e) => {
        if (e.matches) {
          this.device = "mobile";
        } else {
          this.device = "desktop";
        }
      };
    };

    handleCtaClick = (e) => {
      e.preventDefault();

      switch (this.type) {
        case "single":
          this.doSingle();
          break;
        case "multi":
          this.openMulti();
          break;
        default:
          break;
      }
    };

    doSingle = () => {
      const formData = new FormData();

      formData.append("id", this.cta.dataset.id);
      formData.append("quantity", 1);
      formData.append("properties[_bundle]", false);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          console.log("response: ", response);
          console.log("response.ok: ", response.ok);
          if (response.ok) {
            this.pubsub.pub('cart:rerender');
            setTimeout(() => {
              this.pubsub.pub('cart:add');
            }, 300);
          }
          // if (response.ok) {
          //   if (typeof ga != "undefined")
          //     ga("send", "event", "quickbuy", "click", document.location.href, {
          //       transport: "beacon",
          //     });
          //   _learnq.push([
          //     "track",
          //     "Quickbuy",
          //     { ProductID: parseInt(this.cta.dataset.id) },
          //   ]);
          // }
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    };

    openMulti = () => {
      this.cta.classList.add("is--active", "invert");
      this.quickAddMultiPanel.classList.replace("hidden", "block");

      if (this.device === "mobile") {
        this.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    };

    closeMulti = () => {
      this.cta.classList.remove("is--active", "invert");
      this.quickAddMultiPanel.classList.replace("block", "hidden");
    };

    handleVariantClick = (e) => {
      const formData = new FormData();

      formData.append("id", e.target.dataset.id);
      formData.append("quantity", 1);
      formData.append("properties[_bundle]", false);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          if (response.ok) {
            if (typeof ga != "undefined")
              ga("send", "event", "quickbuy", "click", document.location.href, {
                transport: "beacon",
              });
            _learnq.push([
              "track",
              "Quickbuy",
              { ProductID: parseInt(e.target.dataset.id) },
            ]);

            if (response.ok) {
              this.pubsub.pub("cart:add")
              this.pubsub.pub("cart:rerender")
            }

          }
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        });

      this.closeMulti();
    };

    handleVariantOver = (e) => {
      this.titleHover.innerHTML = e.target.dataset.variantTitle;
      this.descriptionHover.innerHTML = e.target.dataset.variantDescription;
    };

    handleVariantOut = (e) => {
      this.titleHover.innerHTML = "";
      this.descriptionHover.innerHTML = "";
    };

    connectedCallback() {
      this.cta?.addEventListener("click", this.handleCtaClick.bind(this));
      if (this.quickAddMultiPanelClose) {
        this.quickAddMultiPanelClose.addEventListener(
          "click",
          this.closeMulti.bind(this)
        );
      }
      this.variantCtas.forEach((cta) => {
        cta.addEventListener("click", this.handleVariantClick.bind(this));
        cta.addEventListener("mouseover", this.handleVariantOver.bind(this));
        cta.addEventListener("mouseout", this.handleVariantOut.bind(this));
      });
      this.deviceObserver();
    }
    disconnectedCallback() {
      this.cta?.removeEventListener("click", this.handleCtaClick.bind(this));
      if (this.quickAddMultiPanelClose) {
        this.quickAddMultiPanelClose.removeEventListener(
          "click",
          this.closeMulti.bind(this)
        );
      }
      this.variantCtas.forEach((cta) => {
        cta.removeEventListener("click", this.handleVariantClick.bind(this));
        cta.removeEventListener("mouseover", this.handleVariantOver.bind(this));
        cta.removeEventListener("mouseout", this.handleVariantOut.bind(this));
      });
    }
  }
  customElements.define("cart-quick-add", CartQuickAdd);
}
